<div class="sso-diagram-card">
  <div class="sso-diagram-header">
    <h1 class="sso-diagram-title">
      <i class="fas fa-sitemap"></i>
      Sơ đồ tổ chức hệ thống SSO
    </h1>
    <p class="sso-diagram-subtitle">Sơ đồ liên kết phân tầng các ứng dụng thuộc hệ thống Cổng đăng nhập tập trung TMU SSO</p>
  </div>

  <div class="sso-diagram-container">
    <div class="tree">
      <ul>
        <li>
          <div class="node node-root">
            <i class="fa-solid fa-lock"></i> SSO
          </div>
          <ul>
            <!-- Cổng Đào tạo Branch -->
            <li class="branch-daotao">
              <div class="node node-main daotao">
                <div class="icon-circle"><i class="fa-solid fa-graduation-cap"></i></div>
                <a href="https://congdaotao.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Cổng<br>Đào tạo</a>
              </div>
              <ul>
                <li>
                  <div class="node node-sub daotao">
                    <div class="icon-circle"><i class="fa-solid fa-user"></i></div>
                    <a href="https://congdaotao.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Đăng ký</a>
                  </div>
                </li>
                <li>
                  <div class="node node-sub daotao">
                    <div class="icon-circle"><i class="fa-regular fa-calendar-alt"></i></div>
                    <a href="https://congdaotao.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Lịch học</a>
                  </div>
                </li>
                <li>
                  <div class="node node-sub daotao">
                    <div class="icon-circle"><i class="fa-solid fa-clipboard-list"></i></div>
                    <a href="https://congdaotao.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Lịch thi</a>
                  </div>
                </li>
              </ul>
            </li>

            <!-- Học tập Branch -->
            <li class="branch-hoctap">
              <div class="node node-main hoctap">
                <div class="icon-circle"><i class="fa-solid fa-book-open"></i></div>
                <a href="https://lms.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Học tập</a>
              </div>
              <ul>
                <li>
                  <div class="node node-lms">
                    <i class="fa-solid fa-desktop"></i>
                    <a href="https://lms.tmu.edu.vn" target="_blank" rel="noopener noreferrer">LMS</a>
                  </div>
                </li>
              </ul>
            </li>

            <!-- Thư viện Branch -->
            <li>
              <div class="node node-main thuvien">
                <div class="icon-circle"><i class="fa-solid fa-book"></i></div>
                <a href="https://lib.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Thư viện</a>
              </div>
            </li>

            <!-- Cổng việc làm Branch -->
            <li>
              <div class="node node-main vieclam">
                <div class="icon-circle"><i class="fa-solid fa-briefcase"></i></div>
                <a href="https://lib.tmu.edu.vn" target="_blank" rel="noopener noreferrer">Cổng<br>việc làm</a>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
